import axios from 'axios';

export function getCampaignState(campaignId) {
  return axios
    .get(`/api/?entity=campaigns&action=campaign-state&cid=${campaignId}`)
    .then(response => response.data && response.data.data);
}
